import { Pipe, PipeTransform } from '@angular/core';

import { MtnaDataType } from '@mtna/data-core-ui';
import { Variable } from '@mtna/pojo-consumer-ui';

import { RdsDataTypeUtil } from '../core/utils/data-type-util';

@Pipe({
  name: 'rdsIsRecordValueNumber',
})
export class RdsIsRecordValueNumberPipe implements PipeTransform {
  transform(variable: Variable): boolean {
    return RdsDataTypeUtil.isMtnaDataTypeNumeric(variable.dataType as MtnaDataType) && !variable.classificationUri;
  }
}
